var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProductGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-question-circle-mono",
    clipPath: "url(#clip0_96_31905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4025 6.82999C10.2112 7.66266 9.63784 8.02932 9.2185 8.29799C8.7845 8.57532 8.6345 8.69132 8.6345 9.08399C8.6345 9.24312 8.57129 9.39573 8.45877 9.50825C8.34625 9.62078 8.19363 9.68399 8.0345 9.68399C7.87537 9.68399 7.72276 9.62078 7.61024 9.50825C7.49772 9.39573 7.4345 9.24312 7.4345 9.08399C7.4345 8.01399 8.09184 7.59399 8.57184 7.28666C8.95317 7.04332 9.15517 6.89999 9.23317 6.56132C9.3005 6.26732 9.24717 6.00732 9.07317 5.78866C8.84517 5.50266 8.43784 5.31732 8.0345 5.31732C7.3825 5.31732 6.85184 5.84866 6.85184 6.50066C6.85184 6.65979 6.78862 6.8124 6.6761 6.92492C6.56358 7.03744 6.41097 7.10066 6.25184 7.10066C6.09271 7.10066 5.94009 7.03744 5.82757 6.92492C5.71505 6.8124 5.65184 6.65979 5.65184 6.50066C5.65254 5.86895 5.9038 5.26332 6.35048 4.81664C6.79717 4.36995 7.4028 4.1187 8.0345 4.11799C8.8005 4.11799 9.55784 4.47132 10.0118 5.04132C10.4132 5.54532 10.5518 6.18066 10.4025 6.82999ZM8.04517 11.9893C7.833 11.9893 7.62951 11.905 7.47949 11.755C7.32946 11.605 7.24517 11.4015 7.24517 11.1893C7.24517 10.9772 7.32946 10.7737 7.47949 10.6236C7.62951 10.4736 7.833 10.3893 8.04517 10.3893C8.25734 10.3893 8.46083 10.4736 8.61086 10.6236C8.76089 10.7737 8.84517 10.9772 8.84517 11.1893C8.84517 11.4015 8.76089 11.605 8.61086 11.755C8.46083 11.905 8.25734 11.9893 8.04517 11.9893ZM7.99984 0.666656C3.94917 0.666656 0.666504 3.94999 0.666504 7.99999C0.666504 12.0507 3.94917 15.3333 7.99984 15.3333C12.0498 15.3333 15.3332 12.0507 15.3332 7.99999C15.3332 3.94999 12.0498 0.666656 7.99984 0.666656Z",
    fill: "#414B56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_31905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductGuide);
export default __webpack_public_path__ + "static/media/icon_product_guide.3428008471f0e385577d6818e51f53bc.svg";
export { ForwardRef as ReactComponent };